import { TableHead, TableRow, TableCell, Checkbox } from '@mui/material'
import { useTranslation } from 'react-i18next'

const columnNames = [
  'id',
  'company',
  'projectName',
  'projectNumber',
  'researchArea',
  'location',
  'round',
  'species',
  'observationType',
  'observationDate',
  'createdBy',
  'foundSpecies',
  'amount',
  'behaviour',
  'placeTypeFound',
  'isApproved',
]

export type ObservationLogsTableHeadProps = {
  onSelectAll: () => void
  isAllSelected: boolean
  isIndeterminate: boolean
}

export const ObservationLogsTableHead = ({
  onSelectAll,
  isAllSelected,
  isIndeterminate,
}: ObservationLogsTableHeadProps): JSX.Element => {
  const { t } = useTranslation('observationLogs')

  return (
    <TableHead sx={{ borderRadius: 8 }}>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            sx={{
              color: 'common.white',
              '&.Mui-checked': {
                color: 'common.white',
              },
              '&.MuiCheckbox-indeterminate': {
                color: 'common.white',
              },
            }}
            indeterminate={isIndeterminate}
            checked={isAllSelected}
            onChange={onSelectAll}
          />
        </TableCell>
        {columnNames.map((columnName) => (
          <TableCell key={columnName}>
            {t(`columnNames.${columnName}`)}
          </TableCell>
        ))}
        <TableCell />
      </TableRow>
    </TableHead>
  )
}
